export enum AddressType {
  Address = 'Address',
  Commercial = 'Commercial',
  Locality = 'Locality',
  Postcode = 'Postcode',
  Residential = 'Residential',
}
